<template>
    <div class="textarea-component">
        <b-input 
            type="textarea"
            :placeholder="placeholder"
            :required="required"
            v-bind:value="value"
            v-on:input="$emit('input', $event)">
        </b-input>
    </div>
</template>

<script>

export default {
    name: 'Textarea',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {
        placeholder () {
            return this.component.placeholder ?? null
        },
    }
}

</script>

<style>

</style>

